import { PersonNameFragment } from "gql/graphql";
import {
  Hidable,
  HiddenLabel,
  isHidden,
  NotSpecified,
  Value,
} from "@/shared/value";
import { isNameHidden, namePartValue } from "../utils/person-name-part";
import { PersonNameFormat, toPersonName } from "../utils/to-person-name";

export function PersonName({
  data,
  format = "full",
}: {
  data?: Hidable<PersonNameFragment>;
  format?: PersonNameFormat;
}) {
  return (
    <Value data={data}>
      {(person) => {
        // Отчество не участвует в проверке там, где оно и не показывается: иначе
        // видимое отчество при закрытых имени и фамилии дало бы пустую строку.
        const parts =
          format === "name"
            ? [person.lastName, person.firstName]
            : [person.lastName, person.firstName, person.middleName];

        if (isNameHidden(...parts)) {
          return <HiddenLabel data={parts.find(isHidden)} />;
        }

        const name = toPersonName(
          format,
          namePartValue(person.lastName),
          namePartValue(person.firstName),
          namePartValue(person.middleName),
        );

        // Части имени видны, но пусты — это незаполненное поле, а не скрытое.
        if (!name) {
          return <NotSpecified />;
        }

        // Имя часто стоит в узкой ячейке и обрезается многоточием — с нативным
        // тултипом оно остаётся читаемым, где бы компонент ни оказался.
        return <span title={name}>{name}</span>;
      }}
    </Value>
  );
}
